import { ITranslations } from "./languages";

export const LanguageData: ITranslations = {
  login: {
    login: 'log in',
    forgetPassword: 'Wachtwoord vergeten',
    colofon: 'Colofon',
    inschrijven: 'registreren',
    benjenieuwhier: 'Ben je nieuw hier? Klik op inschrijven.',
    klaar: 'klaar',
    username: 'gebruikersnaam',
    password: 'wachtwoord',
    dutch: 'Nederlands',
    english: 'English',
    manualDownload: 'Handleiding'
  },
  global: {
    back: 'Terug',
    continue: 'GA VERDER',
    next: 'Volgende',
    done: 'Gedaan',
    playagain: 'nog een keer'
  },
  register: {
    subscribe: 'Schrijf je in',
    requiredFields: 'Deze velden zijn verplicht',
    passwordConfirm: 'Wachtwoord nog een keer',
    emailAddress: 'E-mail adres'
  },
  createAvatar: {
    'chooseYourAvatar': 'Kies je eigen avatar',
    'skinLight': 'lichte huidskleur',
    'skinMiddle': 'middel huidskleur',
    'skinDark': 'donkere huidskleur',
    'remarks': 'Kies nu je eigen karakter. Als je tevreden bent, klik je op Ga Verder!'
  },
  dashboard: {
    logout: 'Uitloggen',
    chooseItem: 'Kies het juiste voorwerp om het level te openen'
  },
  diploma: {
    thisisforyou: 'Na alles wat jij gedaan hebt, is deze voor jou!',
    instruction: 'Vul je e-mail adres in en klik op versturen om dit diploma in je mailbox te ontvangen.',
    send: 'Verstuur',
    ready: 'Klaar'
  },
  games: {
    instruction: 'UITLEG',
    goodbad: 'Goed/fout vragen',
    good: 'Goed',
    bad: 'Fout',
    helpingToughts: 'Helpende / niet helpende gedachten',
    questions: 'Vragen',
    chooseEmotion: 'Kies de passende emoties',
    stresshead: 'Stresshoofd',
    moveArrow: 'Verschuif de pijl',
    wellDone: 'Goed gedaan, je mag door!',
    title_GameVideo: 'Video',
    title_GameMultipleChoice: 'Vragen',
    title_GameMemory: 'Kies de passende emotie',
    title_GameHelpendeGedachten: 'Helpende / niet helpende gedachten',
    title_GameStresshoofd: 'Stresshoofd',
    title_GameGoodBad: 'Goed/fout vragen',
    title_GameClicker: 'Zoek',
    clicker_response_plural: 'Goed gedaan, je hebt {{foundBroedels}} broedels gevonden!',
    clicker_response: 'Goed gedaan, je hebt {{foundBroedels}} broedel gevonden!',
    print_worksheet: 'Print werkblad',
    clicker_beginner: 'Makkelijk',
    clicker_expert: 'Moeilijk',
 }

};
